import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import {ThirdpartyDocAemDataObject} from "@app/models/aem.model";
import { environment } from '@environments/environment';


@Injectable({
  providedIn: 'root'
})
export class CaasService {
  private caasData: any;
  constructor(private readonly http: HttpClient) { }

  getContent() {
      return firstValueFrom(this.http.get<ThirdpartyDocAemDataObject>(`${environment.THIRDPARTY_DOCUMENTS.BASE_URL}${environment.THIRDPARTY_DOCUMENTS.CAAS_URL}`)).then((response) => {
      this.caasData = response;
    }).catch((err) => {
      console.error('Caas error'+err);
    });
  }
  getCaasData() {
    return this.caasData;
  }
}
